import { render, staticRenderFns } from "./AlertComponent.vue?vue&type=template&id=735ba380&scoped=true"
import script from "./AlertComponent.vue?vue&type=script&lang=js"
export * from "./AlertComponent.vue?vue&type=script&lang=js"
import style0 from "./AlertComponent.vue?vue&type=style&index=0&id=735ba380&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735ba380",
  null
  
)

export default component.exports